import React from 'react'
import PropTypes from 'prop-types'
import './styles.scss'

const Checkbox = ({
  className,
  value,
  name,
  label,
  onChange,
  checked,
  required,
  invalid,
}) => {
  return (
    <div className={`checkbox--custom ${className || ''}`}>
      <input
        type="checkbox"
        name={name}
        value={value}
        onChange={onChange}
        checked={checked}
        required={required}
        disabled={invalid}
        className="checkbox--custom-input"
        id={name}
      />
      {
        label ? (
          <label htmlFor={name} className="checkbox--custom-label">
            {label}
          </label>
        ) : null
      }
    </div>
  )
}

Checkbox.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string.isRequired,
  name: PropTypes.string,
  label: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool,
  required: PropTypes.bool,
  invalid: PropTypes.bool,
}

export default Checkbox